import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./AboutUs.css"; // Import your custom CSS

const AboutUs = () => {
  return (
    <div className="container-fluid position-relative overflow-hidden about-us-container py-5">
      <img
        src="/assets/Images/bg-flower.png"
        className="img-fluid position-absolute bg-flower top-left"
        alt="Flower decoration"
      />
      <img
        src="/assets/Images/bg-flower.png"
        className="img-fluid position-absolute bg-flower bottom-right"
        alt="Flower decoration"
      />
      <div className="container py-5 mt-3 position-relative">
        <div className="row g-5 align-items-center">
          <div className="col-xl-6 col-lg-12 wow fadeIn" data-wow-delay="0.1s">
            <div className=" img-container">
              <img
                src="/assets/Images/about-4.png"
                className="img-fluid lg-w-100 sm:height-[200px] "
                alt="About us"
              />
            </div>
          </div>
          <div className="col-xl-6 col-lg-12">
            <div className="wow fadeIn" data-aos="fade-down">
              <h1 className="display-3 text-center mb-4">About us</h1>
              <h2 className="display-5 text-dark mb-4">
                We Craft Memorable Moment
              </h2>
              <p className="text-dark fs-3 text-justify mb-4">
                Cosmical Event Planners is all set to initiate into the domain
                of event management with a team strategically equipped to
                challenge the prevailing drawbacks of the field. We are
                enthralled to serve your wishes and manifest just the right
                picture of your envisioned big days. Currently we are focusing
                on our customers to provide a wide range of event services
                namely Destination Weddings & Major Corporate Events on the mega
                side to Birthday or Kitty Parties or any of Your Wishful Event
                within the geographical bounds of Jaipur. Gradually with your
                good wishes and trust we intend on fanning out throughout the
                Nation and beyond.
              </p>
              <p className="text-dark fs-3 text-justify mb-4">
                We offer you a blend of all the available options in the market,
                thus giving you an optimal digital platform for making
                well-informed choices. Cosmical Event Planners is your one-place
                solution for all sorts of budget-friendly and bespoke event
                productions to remember. Prioritizing our customers’ perspective
                by building their confidence and delivering the trust you put in
                us is the fuel to our Company's Vision and Mission. With you,
                from the sprout of an idea to its fruitful execution, we
                relentlessly work to deliver you the best by carving out a
                glimpse of the cosmos into your events.{" "}
              </p>

              <div className="d-flex mt-5 flex-column flex-md-row call-section">
                {/* <div className="d-flex align-items-center justify-content-center flex-shrink-0 mb-3 mb-md-0"> */}
                  {/* <a
                    href="#"
                    className="btn btn-secondary fs-3 btn-primary-outline-0 py-3 px-4"
                  >
                    Read More
                  </a> */}
                {/* </div> */}
                <div className="d-flex align-items-center ms-md-4 call-section">
                  <div className="d-inline-block me-3">
                    <i className="fa fa-phone fa-2x text-primary"></i>
                  </div>
                  <div className="d-inline-block">
                    <h4 className="text-dark fw-bold mb-0">Call Us Anytime</h4>
                    <h4 className="text-dark fw-bold mb-0">+91 9929925236</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        {/* <div className="bg-light">
          <div className="container py-5">
            <div className="row h-100 align-items-center py-5">
              <div className="col-lg-6">
                <h1 className="display-4">About us page</h1>
                <p className="lead text-muted mb-0">Create a minimal about us page using Bootstrap 4.</p>
                <p className="lead text-muted">Snippet by <a href="https://bootstrapious.com/snippets" className="text-muted">
                  <u>Bootstrapious</u></a>
                </p>
              </div>
              <div className="col-lg-6 d-none d-lg-block"><img src="https://bootstrapious.com/i/snippets/sn-about/illus.png" alt className="img-fluid" /></div>
            </div>
          </div>
        </div> */}
        <div className=" py-5">
          <div className="container py-5">
            <div className="row align-items-center mb-5">
              <div className="col-lg-6 order-2 order-lg-1">
                <h2 className="display-5 text-dark mb-4">
                  Offers to our most trusted brand – Our Customers
                </h2>
                <p className="text-dark text-justify fs-3 mb-4" >
                  <ul>
                    <li>
                      <strong>Budgeting:</strong> We relieve you of one of the
                      most arduous tasks of any event—budget allocation to each
                      vendor. According to your requirements, we help you out
                      with our experience.
                    </li>
                    <li>
                      <strong>Vendor Recommendation:</strong> After analyzing
                      your budget, our AI-enabled software provides you with the
                      list of the most suitable vendors for your event across
                      multiple essential services.
                    </li>
                    <li>
                      <strong>Price Negotiation:</strong> Our team stands by you
                      at the most crucial point of price negotiation with the
                      vendor to grab the most efficient and fair offer that's
                      easy on your pockets.
                    </li>
                    <li>
                      <strong>Event Coordinator:</strong> To save you from being
                      thrown into disarray on your important day, our event
                      coordinator will hold the fort on your front to take care
                      of all your needs, relieving you to enjoy the moment.
                    </li>
                    <li>
                      <strong>Post-Event Evaluation:</strong> We value your
                      feedback on your experience with us. Your evaluation
                      becomes a source of understanding for the constant
                      improvement of our services.
                    </li>
                  </ul>
                </p>
                {/* <a
                  href="#"
                  className="btn btn-secondary fs-3 btn-primary-outline-0 py-3 px-4"
                >
                  Learn More
                </a> */}
              </div>
              <div className="col-lg-5 px-5 mx-auto order-1 order-lg-2 img-container">
                <img
                  src="/assets/Images/about-3.jpg"
                  alt="about-1"
                  className="img-fluid mb-4 mb-lg-0"
                />
              </div>
            </div>
            <div className="row align-items-center">
              <div className="col-lg-5 px-5 mx-auto img-container">
                <img
                  src="/assets/Images/about-2.png"
                  alt="about-2"
                  className="img-fluid mb-4 mb-lg-0"
                />
              </div>
              <div className="col-lg-6">
                <h2 className="display-5 text-dark mb-4">
                  HOW WE ASSIST YOU IN YOUR ENDEAVORS
                </h2>
                <p className="text-dark text-justify fs-3 mb-4">
                  <ul>
                    <li>
                      <strong>Requirement Statement:</strong> We begin by
                      acquiring a statement from you directly through our
                      website, wherein you describe your vision for your
                      upcoming event.
                    </li>
                    <li>
                      <strong>Discussion and Budgeting:</strong> Budget
                      allocation for each vendor follows a deep understanding of
                      your needs, demands, and desires within a stipulated
                      budget and period for an impeccable production of your
                      event.
                    </li>
                    <li>
                      <strong>Vendor Recommendations:</strong> Accordingly, a
                      list of vendors for specific services like venue,
                      photography, catering, logistics, decor, and others will
                      be sent over email. Disclosing all necessary details, the
                      final selection of vendors rests in your hands.
                    </li>
                    <li>
                      <strong>Vendor Visiting:</strong> Once you fully invest
                      your trust in us, we shall earmark a dedicated event
                      coordinator, arrange meetings with vendors of your choice,
                      and work forward to achieve the best possible offer for
                      your event.
                    </li>
                    <li>
                      <strong>Contract:</strong> We fulfill our promise of
                      strengthening your confidence by being a party to the most
                      advantageous contracts signed between you and the vendors.
                    </li>
                    <li>
                      <strong>Event Coordinator:</strong> On your big day, our
                      representative will coordinate the whole event and take
                      the load of all the stressful management off your
                      shoulders. Our event coordinator will personally ensure
                      that all is delivered as promised.
                    </li>
                    <li>
                      <strong>Evaluation:</strong> The event will successfully
                      culminate with your assessment of our services. In this
                      last phase, you will rate our representatives and vendors
                      on a scale of 1-10, expressing your satisfaction with our
                      services.
                    </li>
                  </ul>
                </p>
                {/* <a
                  href="#"
                  className="btn btn-secondary fs-3 btn-primary-outline-0 py-3 px-4"
                >
                  Learn More
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
